import { defineStore } from 'pinia';

export const useMainStore = defineStore('store', {
  state: () => {
    return {
      user: {
        id: null,
        first_name: null,
        last_name: null,
        avatar_url: null,
        roles: null,
      },
    };
  },
  getters: {
  },
  actions: {
  },
});
